import axios from 'axios';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && body.success === true) return body.data ?? null;
  return body ?? null;
}

const users = (apiUrl) => `${apiUrl}/api/users`;

export async function changePasswordRequest(apiUrl, currentPassword, newPassword) {
  return unwrap(await axios.post(`${apiUrl}/api/auth/change-password`, {
    current_password: currentPassword,
    new_password: newPassword,
  }));
}

export async function listUsers(apiUrl) {
  return unwrap(await axios.get(users(apiUrl)));
}

/** body: {email, name, role, person_id?}; the response carries a one-time temporary_password. */
export async function createUser(apiUrl, body) {
  return unwrap(await axios.post(users(apiUrl), body));
}

/** body: any of {name, role, person_id, active} */
export async function updateUser(apiUrl, userId, body) {
  return unwrap(await axios.patch(`${users(apiUrl)}/${encodeURIComponent(userId)}`, body));
}

export async function resetUserPassword(apiUrl, userId) {
  return unwrap(await axios.post(`${users(apiUrl)}/${encodeURIComponent(userId)}/reset-password`));
}

export const ROLE_LABELS = {
  admin: 'Admin',
  manager: 'Manager',
  salesperson: 'Salesperson',
  staff: 'Staff',
};

/** Only admins see the full dashboard. Everyone else gets the lead-routing view alone. */
export function isAdminUser(user) {
  return !user || !user.role || user.role === 'admin';
}
